import React, { ReactNode, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateItem } from '../../../../state/usecase/tableone/action';
import { TableOne } from '../../../../domain/careplan/tableone/TableOne';
import { TableOnePath } from '../../../../domain/careplan/tableone/TableOnePath';
import { TableOneUpdaterOf, FieldProps } from './TableOneUpdaterOf';
import {
  SaveIndicator,
  SaveIndicatorStatus,
} from '../../assessmentsheet/components/sections/SaveIndicator';

export class GroupedTableOneUpdater implements TableOneUpdaterOf {
  private readonly projectId: string;

  private readonly tableOne: TableOne | null;

  readonly saveIndicator: ReactNode;

  private readonly setSaveIndicatorStatus: (
    saveIndicatorStatus: SaveIndicatorStatus,
  ) => void = () => {};

  private readonly activated: boolean;

  constructor(
    projectId: string,
    tableOne: TableOne | null,
    activated: boolean,
  ) {
    this.projectId = projectId;
    this.tableOne = tableOne;
    const [saveIndicatorStatus, setSaveIndicatorStatus] = useState(
      SaveIndicatorStatus.INITIAL,
    );
    this.saveIndicator = <SaveIndicator status={saveIndicatorStatus} />;
    this.setSaveIndicatorStatus = setSaveIndicatorStatus;
    this.activated = activated;
  }

  of<T>(path: string, build: (props: FieldProps<T>) => ReactNode): ReactNode {
    const pathObject = new TableOnePath(path);

    const [readonly, setReadonly] = useState(false);
    const dispatch = useDispatch();

    const value = this.tableOne?.getValue<T>(pathObject);
    const update = (value: T) => {
      const originalValue = this.tableOne?.getValue<T>(pathObject);
      if (originalValue === undefined) return;
      if (value === originalValue) return;
      setReadonly(true);
      this.setSaveIndicatorStatus(SaveIndicatorStatus.SAVING);
      const onSuccess = () => {
        this.setSaveIndicatorStatus(SaveIndicatorStatus.SUCCESSFUL);
        setReadonly(false);
      };
      const onFailure = () => {
        this.setSaveIndicatorStatus(SaveIndicatorStatus.FAILED);
        setReadonly(false);
      };
      dispatch(
        updateItem(
          this.projectId,
          pathObject,
          value,
          originalValue,
          onSuccess,
          onFailure,
        ),
      );
    };
    const disabled = value === undefined || !this.activated;

    return build({ path, value, update, disabled, readonly });
  }
}
